import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03daa610"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "link-dialog" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 2,
  class: "preview"
}
const _hoisted_5 = { class: "btns" }

import { computed, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTElementLink } from '@/types/slides'
import useLink from '@/hooks/useLink'
import { useI18n } from 'vue-i18n'
import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'
import {
  Button,
  Select,
  Input,
} from 'ant-design-vue'
type TypeKey = 'web' | 'slide'
interface TabItem {
  key: TypeKey
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkDialog',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const { t, locale } = useI18n();

const SelectOption = Select.Option



const { handleElement } = storeToRefs(useMainStore())
const { slides, currentSlide } = storeToRefs(useSlidesStore())

const type = ref<TypeKey>('web')
const address = ref('')
const slideId = ref('')

slideId.value = slides.value.find(item => item.id !== currentSlide.value.id)?.id || ''

const selectedSlide = computed(() => {
  if (!slideId.value) return null

  return slides.value.find(item => item.id === slideId.value) || null
})

const tabs: TabItem[] = [
  { key: 'web', label: t(`editor.canvas.linkDialog.pageUrl`) },
  { key: 'slide', label: t(`editor.canvas.linkDialog.pptPage`) },
  // { key: 'web', label: '网页链接' },
  // { key: 'slide', label: '幻灯片页面' },
]

const { setLink } = useLink()

onMounted(() => {
  if (handleElement.value?.link) {
    if (handleElement.value.link.type === 'web') address.value = handleElement.value.link.target
    else if (handleElement.value.link.type === 'slide') slideId.value = handleElement.value.link.target

    type.value = handleElement.value.link.type
  }
})

const save = () => {
  const link: PPTElementLink = {
    type: type.value,
    target: type.value === 'web' ? address.value : slideId.value,
  }
  if (handleElement.value) {
    const success = setLink(handleElement.value, link)
    if (success) emit('close')
    else address.value = ''
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["tab", { 'active': type.value === tab.key }]),
          key: tab.key,
          onClick: ($event: any) => (type.value = tab.key)
        }, _toDisplayString(tab.label), 11, _hoisted_3)
      }), 64))
    ]),
    (type.value === 'web')
      ? (_openBlock(), _createBlock(_unref(Input), {
          key: 0,
          class: "input",
          value: address.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((address).value = $event)),
          placeholder: _unref(t)(`editor.canvas.linkDialog.url`)
        }, null, 8, ["value", "placeholder"]))
      : _createCommentVNode("", true),
    (type.value === 'slide')
      ? (_openBlock(), _createBlock(_unref(Select), {
          key: 1,
          class: "input",
          value: slideId.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((slideId).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, index) => {
              return (_openBlock(), _createBlock(_unref(SelectOption), {
                key: slide.id,
                value: slide.id,
                disabled: _unref(currentSlide).id === slide.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`editor.canvas.linkDialog.ppt`)) + " " + _toDisplayString(index + 1), 1)
                ]),
                _: 2
              }, 1032, ["value", "disabled"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true),
    (type.value === 'slide' && _unref(selectedSlide))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t(`editor.canvas.linkDialog.preView`)) + "：", 1),
          _createVNode(ThumbnailSlide, {
            class: "thumbnail",
            slide: _unref(selectedSlide),
            size: 490
          }, null, 8, ["slide"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Button), {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close'))),
        style: {"margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`public.cancel`)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (save()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`public.ok`)), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})